import { Avatar, Box, Grid, Typography, useTheme, Stack } from "@mui/material"

import { Head } from "components/Head"
import { useTranslation } from "providers/i18n"
import { ImageCard } from "components/ImageCard"
import { useVenue } from "providers/venue"
import { CustomIcon } from "components/icons"
import { getFeatureDetail } from "utils/feature"
import { Link } from "react-router-dom"
import { useLoveEat } from "extensions/love-eat/hooks/useLoveEat"
import _ from "lodash"

export const LoveEatPage = () => {
  const { isMultiOrdinalVenue } = useVenue()
  const { levels, restaurantGroupedByLevel } = useLoveEat()
  const { t } = useTranslation()

  const theme = useTheme()
  const { styleOverrides = {} } = theme.components?.[`AppLoveEat`] || {}
  const { diningImageCard, levelStack, diningAvatar, diningAvatarFallBack } =
    styleOverrides

  return (
    <>
      <Head title={t("Love Eat")} />
      <Stack sx={levelStack}>
        {levels.map((level) => {
          const levelName = _.get(level, "properties.name.en", "")
          const restaurants = _.get(restaurantGroupedByLevel, levelName, [])
          return (
            <Box key={level.id}>
              <Typography variant="heading" component="h2" gutterBottom>
                {levelName}
              </Typography>
              <Grid container spacing={1}>
                {Array.isArray(restaurants) &&
                  restaurants.map((restaurant) => {
                    const {
                      group,
                      level,
                      logo,
                      featuredImage,
                      name,
                      isFeatured,
                    } = getFeatureDetail(restaurant) || {}
                    const levelText = isMultiOrdinalVenue
                      ? t("Level Text", { level: t(level) })
                      : ""
                    const groupText = group ? t(group) : ""
                    const fallBackIcon = _.first(
                      restaurant?.properties?.local_parent_categories
                    )?.properties?.icon_path
                    return (
                      <Grid item xs={6} md={4} lg={3} key={restaurant?.id}>
                        <ImageCard
                          component={Link}
                          to={`/maps/place/${restaurant?.id}`}
                          title={t(name)}
                          subheader={`${levelText} ${groupText}`}
                          image={featuredImage}
                          sx={diningImageCard}
                          avatar={
                            <Avatar src={logo} sx={logo ? {} : diningAvatar}>
                              <CustomIcon
                                path={fallBackIcon}
                                sx={diningAvatarFallBack}
                              />
                            </Avatar>
                          }
                          tag={isFeatured ? t("Highlight") : null}
                        />
                      </Grid>
                    )
                  })}
              </Grid>
            </Box>
          )
        })}
      </Stack>
    </>
  )
}
